import { Grid } from '@mui/material';
import React from 'react';
import { AudienceMeasureConfig, AudienceMeasureTotal, EAudienceMeasureType } from './model';
import { TotalsBox } from './TotalsBox';

interface AudienceTotalBoxesProps {
    values: AudienceMeasureTotal[];
    onMeasureClick?: (measure: EAudienceMeasureType) => void;
    selectedMeasure?: EAudienceMeasureType;
    datePoints: [Date, Date, Date];
    config: Record<EAudienceMeasureType, AudienceMeasureConfig>;
}

export const AudienceMeasureTotalBoxes: React.FC<AudienceTotalBoxesProps> = ({
    values,
    onMeasureClick,
    selectedMeasure,
    datePoints,
    config
}) => {
    const renderMeasure = React.useCallback(
        (option: AudienceMeasureTotal) => (
            <Grid item xs={12} sm={4} key={option.key}>
                <TotalsBox
                    datePoints={datePoints}
                    measure={option}
                    active={option.key === selectedMeasure}
                    onClick={onMeasureClick}
                    config={config}
                />
            </Grid>
        ),
        [datePoints, onMeasureClick, selectedMeasure, config]
    );
    return (
        <Grid container spacing={3}>
            {values.map(renderMeasure)}
        </Grid>
    );
};
